module.exports = __webpack_public_path__ + "media/images/history-425345a344ab37085b835d0529f5e1a5.png";